import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68850d48&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=68850d48&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=68850d48&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68850d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68850d48')) {
      api.createRecord('68850d48', component.options)
    } else {
      api.reload('68850d48', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68850d48&scoped=true", function () {
      api.rerender('68850d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/publicTable/index.vue"
export default component.exports